import React from 'react';

//Hooks
import {useState, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';

//Actions
import {getLocales, updateSettings} from '../../../store/actions/index';

//Components
import LanguageInput from '../../../components/ui/LanguageInput/LanguageInput';
import SwitchInput from '../../../components/ui/SwitchInput/SwitchInput';
import Loader from 'react-loader-spinner';
import SubmitButton from '../../../components/ui/SubmitButton/SubmitButton';
import ScreenFooter from '../../../components/ScreenFooter/ScreenFooter';

//Styles
import Styles from './Settings.module.scss';

const Settings = () => {
    const [language, setLanguage] = useState('en');
    const settings = useSelector(state => state.profile.settings);
    const locales = useSelector(state => state.locales.locales);
    const locale = useSelector(state => state.locales.locale);
    const isLoading = useSelector(state => state.ui.isLoading);
    const [disabled, setDisabled] = useState(true);

    const [pushSettings, setPushSettings] = useState(false);
    const [emailSettings, setEmailSettings] = useState(false);
    const [feedbackSettings, setFeedbackSettings] = useState(false);
    const dispatch = useDispatch();

    const {t} = useTranslation('common');

    const {
        pushEnabled,
        mailEnabled,
        feedbackEnabled
    } = settings || {};

    useEffect(() => {
        dispatch(getLocales());
        setLanguage(locale);
        setPushSettings(pushEnabled);
        setEmailSettings(mailEnabled);
        setFeedbackSettings(feedbackEnabled);
    }, [locale, pushEnabled, mailEnabled, feedbackEnabled, dispatch]);

    const saveOptions = () => {
        dispatch(updateSettings({
            locale: language,
            pushEnabled: pushSettings,
            mailEnabled: emailSettings,
            feedbackEnabled: feedbackSettings,
        }))
    };

    const settingsHandler = (id, value) => {
        setDisabled(false);
        switch (id) {
            case 'push':
                setPushSettings(value);
                break;
            case 'email':
                setEmailSettings(value);
                break;
            default:
                setFeedbackSettings(value);
                break;
        }
    };

    if (!locales || !settings) {
        return (
            <div className={Styles.container}>
                <Loader type="TailSpin" color="#000" height={40} width={40}/>
            </div>
        )
    }

    return (
        <>
            <div className={Styles.container}>
                <LanguageInput
                    data-testid='input1'
                    languageHandler={(language) => {
                        setDisabled(false)
                        setLanguage(language)
                    }}
                    value={language}
                    locales={locales}
                />
                <SwitchInput
                    data-testid='switch1'
                    switchHandler={settingsHandler}
                    name={t('myProfile.settings.enablePushMessages')}
                    id='push'
                    value={pushSettings}
                />
                <SwitchInput
                    data-testid='switch2'
                    switchHandler={settingsHandler}
                    name={t('myProfile.settings.enableEmailMessages')}
                    id='email'
                    value={emailSettings}
                />
                <SwitchInput
                    data-testid='switch3'
                    switchHandler={settingsHandler}
                    name={t('myProfile.settings.enableFeedback')}
                    id='feedback'
                    value={feedbackSettings}
                />

            </div>
            <ScreenFooter visible={true}>
                <SubmitButton
                    data-testid='button1'
                    submitHandler={saveOptions}
                    isLoading={isLoading}
                    disabled={disabled}
                >
                    {t('myProfile.editAccount.save').toUpperCase()}
                </SubmitButton>
            </ScreenFooter>
        </>
    )
}


export default Settings